module.exports = __webpack_public_path__ + "static/media/COOLING_COUNTER_EN.c9890c4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/COOLING_COUNTER_EN.png
// module id = 671
// module chunks = 0